<template>
  <div>
    <p v-if="developmentMode">
      <strong>The current environment is <span v-if="environment">{{ environment }}</span> using the backend at </strong>{{ apiBase }}.
    </p>
    <p v-if="developmentMode && projectVersion">
      <strong>Amaze UI Version: </strong>{{ projectVersion }}
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      developmentMode: process.env.VUE_APP_DEVELOPMENT_FLAG.toLowerCase() === 'true',
      apiBase: process.env.VUE_APP_API_BASE,
      environment: process.env.NODE_ENV,
      projectVersion: require('../../../package.json').version
    }
  }
}
</script>
